<script setup lang="ts">
import { CustomMarker } from "vue3-google-map";
import IconPin from "@/assets/icons/pin-fill.svg?component";
const props = defineProps(["title", "options"]);
</script>

<template>
  <CustomMarker class="marker" :options="props.options">
    <IconPin class="pin" />
    <slot />
  </CustomMarker>
</template>

<style>
.marker .pin {
  width: 26px;
  fill: var(--cl-orange);
  stroke: var(--cl-white);
  stroke-width: 1px;
}
.marker .pin circle {
  fill: var(--cl-white);
}
</style>
